<template>
    <div>
        <common-table
                :table-columns="tableColumns"
                :url="url" :operate="operate"
                :form-fields="formFields"
                :permission="permission"
                :searchs="searchs"
                ref="table"
                :buttons="buttons"
        />

        <!--转账（u）弹出框-->
        <div class="dialog">
            <el-dialog title="转账(TRX)" :visible.sync="transferVisible" custom-class="common-dialog" :close-on-click-modal="false" width="30%">
                <div class="dialog_body">
                    <el-form label-position="right" status-icon label-width=""
                             :model="transferForm" ref="transferForm">

                        <el-form-item label="" prop="toAddress" :rules="[]">
                            <div>
                                <el-input placeholder="转账地址" v-model="transferForm.toAddress">
                                    <template slot="prepend">转账地址</template>
                                </el-input>
                            </div>
                        </el-form-item>

                        <el-form-item label="" prop="amount" :rules="[]">
                            <div>
                                <el-input placeholder="转账金额(TRX)" v-model="transferForm.amount">
                                    <template slot="prepend">转账金额</template>
                                </el-input>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="transferVisible = false">取 消</el-button>
                    <el-button type="primary" size="small" @click="submitTransferForm">确 定</el-button>
                </div>
            </el-dialog>
        </div>

        <div class="dialog">
            <el-dialog title="归集金额"
                       :visible.sync="collectionVisible"
                       custom-class="common-dialog"
                       :close-on-click-modal="false"
                       width="30%">
                <div class="dialog_body">
                    <el-form label-position="right" status-icon label-width="90px"
                             :model="collectionForm" ref="collectionForm">
                        <el-form-item label="代理" prop="agentId" :rules="[{message: '请选择代理', trigger: 'blur', required: true}]">
                            <el-select filterable
                                       v-model="collectionForm.agentId" clearable
                                       placeholder="请选择代理"
                                       size="medium" class="mr10 mb-10">
                                <el-option v-for="(option, index) in agents" :key="index" :label="option.name" :value="option.id"/>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="开始时间" prop="startTime" :rules="[{message: '请选择开始时间', trigger: 'blur', required: true}]">
                            <el-date-picker v-model="collectionForm.startTime"
                                            placeholder="开始时间"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            type='datetime' align="right"
                                            size="medium" class="mr10 mb-10"/>
                        </el-form-item>
                        <el-form-item label="结束时间" prop="endTime" :rules="[{message: '请选择结束时间', trigger: 'blur', required: true}]">
                            <el-date-picker v-model="collectionForm.endTime"
                                            placeholder="结束时间"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            type='datetime' align="right"
                                            size="medium" class="mr10 mb-10"/>
                        </el-form-item>
                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="collectionVisible = false">取 消</el-button>
                    <el-button type="primary" size="small" @click="submitCollectionForm('collectionForm')">确 定</el-button>
                </div>
            </el-dialog>
        </div>

    </div>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    import message from "../../utils/message";
    export default {
        name: "Wallet",
        components: {CommonTable},
        data(){
            return {
                transferVisible: false,
                transferForm: {
                    toAddress: '',
                    amount: '',
                    fromAddress: ''
                },
                agents: [],
                collectionForm: {
                    agentId: '',
                    startTime: '',
                    endTime: '',
                },
                collectionVisible: false,
                searchs:[{
                    name: 'agentId',
                    placeholder: '代理',
                    type: 'select',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                },{
                    name: 'phone',
                    placeholder: '手机号',
                    type: 'input'
                },{
                    name: 'address',
                    placeholder: '钱包地址',
                    type: 'input'
                }, {
                    name: 'startTime',
                    placeholder: '开始时间',
                    type: 'dateTime'
                }, {
                    name: 'endTime',
                    placeholder: '结束时间',
                    type: 'dateTime'
                }, {
                    name: 'assign',
                    placeholder: '是否分配',
                    type: 'select',
                    selectValue:[{
                        key: 0,
                        value: '未分配'
                    },{
                        key: 1,
                        value: '已分配'
                    }]
                }, {
                    name: 'type',
                    placeholder: '类型',
                    type: 'select',
                    selectValue:[{
                        key: 0,
                        value: '未知'
                    },{
                        key: 1,
                        value: '基础'
                    },{
                        key: 2,
                        value: '推广'
                    }]
                },],
                permission:{
                    add: 'wallet:add',
                    update: 'wallet:update',
                    delete: 'wallet:delete',
                    deleteBatch: 'wallet:deleteBatch'
                },
                url: {
                    get: '/wallet/listByCondition',
                    add: '/wallet/add',
                    update: '/wallet/update',
                    delete: '/wallet/delete/',
                    delete_batch: '/wallet/deleteBatch',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'Id',
                    show: true,
                    width: '',
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select',
                    },
                    detail: false,
                    width: '',
                }, {
                    field: 'phone',
                    label: '用户',
                    show: true,
                    width: '',
                }/*, {
                    field: 'name',
                    label: '钱包名称',
                    show: true,
                    width: '',
                }*/, {
                    field: 'address',
                    label: '钱包地址',
                    show: true,
                    width: '',
                }, {
                    field: 'assign',
                    label: '分配',
                    show: {
                        type: 'tag',
                        tags: [{
                            key: 1,
                            value: '已分配',
                            type: 'success'
                        },{
                            key: 0,
                            value: '未分配',
                            type: 'warning'
                        }]
                    },
                    width: '100'
                }, {
                    field: 'type',
                    label: '类型',
                    show: {
                        type: 'tag',
                        tags: [{
                            key: 0,
                            value: '未知',
                            type: 'danger'
                        }, {
                            key: 1,
                            value: '基础',
                            type: 'primary'
                        },{
                            key: 2,
                            value: '推广',
                            type: 'warning'
                        }]
                    },
                    width: '100'
                }, {
                  field: 'systemBalance',
                  label: '系统余额',
                  show: true,
                  width: '',
                }, {
                    field: 'balance',
                    label: '余额',
                    show: true,
                    width: '',
                },{
                    field: 'createTime',
                    label: '时间',
                    show: true,
                    width: '',
                }],
                operate: [{
                    icon: 'el-icon-files',
                    type: 'text',
                    text: '查询余额',
                    handle: (row) => {
                        this.$axios.post({
                            url: '/wallet/search/balance/' + row.id,
                            success: (res) => {
                                if(res.code === 0){
                                    this.$set(row, 'balance', res.data);
                                }else{
                                    this.$message.error('查询余额失败');
                                }
                            }
                        });
                    }
                },{
                    icon: 'el-icon-money',
                    type: 'text',
                    text: '转账(TRX)',
                    handle: (row) => {
                        this.transferVisible = true;
                        this.transferForm.fromAddress = row.address;
                        this.transferForm.toAddress = '';
                        this.transferForm.amount = '';
                    }
                }],
                formFields: {
                    addTitle: '添加公告',
                    updateTitle: '修改公告',
                    labelWidth: '100px',
                    model: [{
                        field: 'name',
                        label: '钱包名称：',
                        type: 'input',
                        placeholder: '钱包名称',
                        rules:[{message: '请输入钱包名称', trigger: 'blur', required: true}],
                        add: true,
                        update: true,
                    }, {
                        field: 'address',
                        label: '钱包地址：',
                        type: 'input',
                        placeholder: '内容',
                        rules:[{message: '请输入钱包地址', trigger: 'blur', required: false}],
                        add: true,
                        update: true,
                        onlyShow: true,
                    }],
                },
                buttons: [/*{
                    icon: 'el-icon-money',
                    type: 'warning',
                    text: '余额归集',
                    permission: 'wallet:collection',
                    click: () => {
                        if (this.agents.length <= 0) {
                            this.tableColumns.some(item => {
                                if (item.field === 'agentId') {
                                    this.agents = item.selectData;
                                }
                            })
                        }
                        this.collectionForm.agentId = '';
                        this.collectionForm.startTime = '';
                        this.collectionForm.endTime = '';
                        this.collectionVisible = true;
                    }
                }*/]
            }
        },
        methods: {
            submitTransferForm(){
                if (!this.transferForm.toAddress) {
                    this.$alert("转账地址不能为空");
                    return;
                }
                if (!this.transferForm.amount) {
                    this.$alert("转账金额不能为空");
                    return;
                }
                // 正则
                let reg = new RegExp(/(^[1-9]([0-9]+)?(\.[0-9]{1,6})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/);
                if (!reg.test(this.transferForm.amount)){
                    this.$alert("请输入正确的金额格式");
                    return;
                }
                //console.log(this.transferForm);
                this.$axios.post({
                    url: '/wallet/transferTrx',
                    data: this.transferForm,
                    confirm: '确定转账到' + this.transferForm.toAddress + "?",
                    success: (res) => {
                        if (res.code == 0){
                            message.success("转账成功");
                            this.transferVisible = false;
                            this.$refs.table.getData();
                        }else {
                            message.error(res.msg || "转账失败");
                        }
                    }
                });
            },
            submitCollectionForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$axios.post({
                            url: '/wallet/collection',
                            confirm: '确定对余额进行归集吗？',
                            data: this.collectionForm,
                            success: (res) => {
                                if (res.code === 0) {
                                    this.collectionVisible = false;
                                    this.$message.success('成功，正在归集中！')
                                } else {
                                    this.$message.error(res.msg || '余额归集任务进行中');
                                }
                            }
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
